import { useCallback } from 'react';
import { useAuth } from '@/auth/authContext';
import { hasDraft } from '@/services/listingDraft';
import { tr } from '@/i18n/tr';
import { useConfirm } from './confirmContext';
import { useUnsaved } from './unsavedContext';

/**
 * Confirms a logout with copy worded for whatever is actually at risk, and
 * resolves true when the user agreed. Always ONE dialog — never a discard
 * prompt chained onto a logout prompt.
 *
 * Lives in one place because there are three logout surfaces — the header
 * avatar menu, the desktop sidebar footer, and the profile header — and a
 * fourth would otherwise be added without any of this.
 */
export function useLogoutConfirm(): () => Promise<boolean> {
  const { user } = useAuth();
  const confirm = useConfirm();
  const { kind } = useUnsaved();

  return useCallback(() => {
    const copy =
      kind === 'edits'
        ? tr.confirm.logoutWithEdits
        : kind === 'photos' || (user !== null && hasDraft(String(user.id)))
          ? tr.confirm.logoutWithListing
          : tr.confirm.logout;
    return confirm(copy);
  }, [kind, user, confirm]);
}
